<article
  class="personal-item pointer"
  [ngClass]="{ 'personal-item--compact': compact }"
>
  <header class="personal-item__section">
    <div class="checkbox" (click)="$event.stopPropagation()">
      <input
        type="checkbox"
        [(ngModel)]="item.selected"
        (ngModelChange)="triggerSelect()"
        [id]="item.id"
      />
      <label [for]="item.id">
        <div class="checkbox__el"></div>
      </label>
    </div>

    <h3 class="personal-item__title">
      {{
        item.name ||
          ('BATCH_MAILING.BATCHES_TAB.BATCH' | translate) + ' №' + item.id
      }}

      <p class="personal-item__title-extra">
        @switch (item.status) {
          @case ('uncommitted') {
            {{ ('BATCH_MAILING.BATCHES_TAB.CREATED_AT' | translate) + ':' }}
            <br />
            {{
              dayjs(item?.created_at, 'YYYY-MM-DD HH:mm').format(
                'DD.MM.YYYY HH:mm'
              ) || '-'
            }}
          }
          @case ('committed') {
            {{ ('BATCH_MAILING.BATCHES_TAB.FORMATION_DATE' | translate) + ':' }}
            <br />
            {{
              dayjs(item?.formation_date, 'YYYY-MM-DD HH:mm').format(
                'DD.MM.YYYY HH:mm'
              ) || '-'
            }}
          }
          @case ('in_ops') {
            {{ ('BATCH_MAILING.BATCHES_TAB.UPDATED_AT' | translate) + ':' }}
            <br />
            {{
              dayjs(item?.update_post_system_at, 'YYYY-MM-DD HH:mm').format(
                'DD.MM.YYYY HH:mm'
              ) || '-'
            }}
          }
        }
      </p>
    </h3>

    <table class="table batches-table">
      <thead>
        <tr>
          <th>{{ 'BATCH_MAILING.BATCHES_TAB.PACKAGE_TYPE' | translate }}</th>
          <th class="small-col">
            {{ 'BATCH_MAILING.BATCHES_TAB.PACKAGE_COUNT' | translate }}
          </th>
          <th class="small-col">
            {{ 'BATCH_MAILING.BATCHES_TAB.TOTAL_WEIGHT' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {{ POSTAL_TYPE_MAP.get(item.postal_delivery_type) | translate }}
          </td>
          @if (item.is_correct_partial_receipt) {
            <td>
              {{ item.total_items }}
            </td>
          } @else {
            <td
              [tooltip]="
                'BATCH_MAILING.BATCHES_TAB.DEPARTURES_IN_BATCH_WITHOUT_ATTACHMENTS'
                  | translate
              "
              class="batches-table-alert-block"
            >
              <p>{{ item.total_items }}</p>
              <p class="batches-table-alert-block-image"></p>
            </td>
          }

          <td>{{ item.total_weight | number: '1.0-2' }}</td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-end status-container">
      <div class="batches-status">
        <span class="batches-status-text">
          {{
            'BATCH_MAILING.BATCHES_TAB.STATUS_' + item.status
              | uppercase
              | translate
          }}
        </span>
      </div>
    </div>
  </header>
</article>
